import { BoxGroup } from 'src/app/models/box-group';
import { Group } from 'src/app/models/group';
import { IBoxAccessibility } from 'src/app/models/interfaces/box-accessibility.interface';
import { IBox } from 'src/app/models/interfaces/box.interface';
import { User } from 'src/app/models/user';
import { FormMode } from '../../controls/common/form-mode';

export class BoxFormContext {
    /**
     * Liste des groupes de bannettes proposés dans la liste déroulante Groupe de bannettes du formulaire.
     */
    groups: BoxGroup[];

    users: User[];

    userGroups: Group[];

    accessibilities: IBoxAccessibility[];

    /**
     * Indique si le formulaire est visible (true) ou pas (false).
     */
    public formVisible = false;

    public mode: FormMode = FormMode.Reading;

    /**
     * Instance de la bannette affichée dans le formulaire.
     */
    public box: IBox;
}
